import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9e3ded0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-width mt-3 mt-lg-0 min-vh-80" }
const _hoisted_2 = { class: "card card-form" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex position-absolute w-100 h-100 align-items-center justify-content-center",
  style: {"background-color":"rgba(255, 255, 255, 0.5)"}
}
const _hoisted_4 = { class: "d-block text-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-success",
  role: "status"
}, null, -1))
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { key: "incomplete" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title text-center fw-bold" }, "Recuperación de contraseña", -1))
const _hoisted_9 = { class: "row gy-3" }
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = { class: "row my-3 mt-5" }
const _hoisted_12 = { class: "col-6 col-md-6 d-flex justify-content-start" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6 col-md-6 d-flex justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-primary px-4 py-2 text-uppercase",
    type: "submit"
  }, "Enviar")
], -1))
const _hoisted_14 = {
  class: "text-center",
  key: "complete"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormEmail = _resolveComponent("FormEmail")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading.status)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("h6", null, _toDisplayString(_ctx.loading.text), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        (!_ctx.complete)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_Form, { onSubmit: _ctx.submitForm }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_FormEmail, {
                        modelValue: _ctx.form.email,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("button", {
                        class: "btn btn-primary px-4 py-2 text-uppercase",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.backClick && _ctx.backClick(...args)), ["prevent"]))
                      }, "Volver")
                    ]),
                    _hoisted_13
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.complete), 1),
              _createElementVNode("h6", null, " Por favor, revisá tu casilla " + _toDisplayString(_ctx.form.email) + " y seguí las indicaciones que encontrarás en el mail para restablecer tu contraseña. ", 1)
            ]))
      ])
    ])
  ]))
}